import React, { useRef, useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import commonDatas  from '../../apps/CommonDatas'
import './Camera.css';

var isVideoLoaded = false;
var webCamWidth = 100;
var webCamHeight = 100;

export function Camera () {
  const location = useLocation();
  const navigate = useNavigate();
  let model = 0;
  let type = 0;
  if( location.state != null ){
    model = location.state.model;
    type = location.state.type;
  }

  let baseIsError = false;
  let isSpecialFlag = false;
  const maskObj = commonDatas.getMaskData(model);
  if( maskObj === null ){
    baseIsError = true;
  }else{
    isSpecialFlag = maskObj['is_special'];
  }
  
  const startMatchFlag = useRef(false);
  const [isStart, setIsStart] = useState(true);
  const [isError, setIsError] = useState(baseIsError);
  const [isLoading, setIsLoading] = useState(true);
  const [typeNo, setTypeNo] = useState(0);
  const [isHorizon, setIsHorizon] = useState(false);
  
  var depth = 4;
  var sizeWidth = 240, sizeHeight = 320;
  var filterSize = 240;
  var filterWidth = 240;
  const filterLeft = useRef(0);
  const filterTop = useRef(0);
  const videoWidth = useRef(0);
  const videoHeight = useRef(0);
  
  if( isSpecialFlag ){
	  filterWidth = 427;
  }
		
  var dispElem    = document.createElement("canvas");
  const onStartPopupCloseClick = function(e){
    e.preventDefault();

    setIsStart(false);
    startMatchFlag.current = true;
  }
  const onResizeMainFrame = function(){
   
    var w = document.body.clientWidth;
    var h = document.body.clientHeight;
    
    if( w > h ){
      setIsHorizon(true);
    }else{
      setIsHorizon(false);
    }
    if( w > h * 1.7786 ){
      w = h * 1.778667;
    }
    document.documentElement.style.setProperty('--content_width', w + "px"); 
  }
    
  useEffect(() => {
	setTypeNo(type);
	
    document.getElementsByTagName("html")[0].scrollTop = 0;
	document.body.scrollTop = 0;
	
	const handleWindowResize = function(){
	  if( isSpecialFlag ){
		onResizeMainFrame();
      }
      onResizeCameraProc();
    }
    const onResizeCameraProc = function(){

	    var contentInner = document.getElementById("content_inner");
	    var videoArea   = document.getElementById("video_area");
	    var videoObj    = document.getElementById("video_obj");
	    var videoElem   = document.getElementById("video_obj");
	
		videoObj.style.height = "auto";
		videoObj.style.width = "auto";
	
		var w, h, vw, vh;
		h = document.body.clientHeight;
	    document.querySelector(':root').style.setProperty('--content_height', h + "px");
	      
		var margin;
	    if( isSpecialFlag ){
	        w = contentInner.clientWidth;
	        var scale = w / 1334;
	        const vr = 1334 / 750;
	
	        vw = (1334 * scale - 2);
	        vh = (750 * scale - 1);
	        videoArea.style.width = vw + "px";
	        videoArea.style.height = vh + "px";
	        videoArea.style.left = ((w - vw) / 2) + "px";
	        
	        if( isVideoLoaded ){
	            webCamWidth = videoElem.videoWidth;
	            webCamHeight = videoElem.videoHeight;

	            if( webCamWidth > 0 && webCamHeight > 0){
		            const webCamRatio = webCamWidth / webCamHeight;
		            margin = vh;

					var vsh, vsw;

		            if( webCamRatio > vr ){
						vsh = (3 * vh);
						vsw = (3 * vh * webCamWidth / webCamHeight);
		
		                videoObj.style.height = vsh + "px";
		                videoObj.style.width = vsw+ "px";
		
		                videoObj.style.top = -margin + "px";
		                videoObj.style.left = "-" + (margin + ((vsw - vsh) / 2) - ((vw - vh) / 2)) + "px";
		                
		                videoWidth.current = filterSize * webCamWidth / webCamHeight;
			            videoHeight.current = filterSize;
			            
			            filterTop.current = 0;
			            filterLeft.current = (videoWidth.current - (videoHeight.current * vr)) / 2; 
		            }else{
						vsw = (3 * vw);
						vsh = (3 * vw * webCamHeight / webCamWidth);
						
		                videoObj.style.width = vsw + "px";
		                videoObj.style.height = vsh + "px";
		
		                videoObj.style.left = -vw + "px";
		                videoObj.style.top = "-" + ((vsh - vh) / 2) + "px";
		                
		                videoWidth.current = filterWidth;
			            videoHeight.current = videoWidth.current * webCamHeight / webCamWidth;
			            
			            filterTop.current = (videoHeight.current - filterSize) / 2;
			            filterLeft.current = 0;
		            }
		            
			        dispElem.width  = videoWidth.current;
			        dispElem.height = videoHeight.current;
		        }
	        }
	        
		}else{
	      w = document.body.clientWidth;
	    
	      vw = w;
	      videoArea.style.width = w + "px";
	      videoArea.style.height = w + "px";
	      videoArea.style.top = 0 + "px";
	      if( isVideoLoaded ){
	        webCamWidth = videoElem.videoWidth;
	        webCamHeight = videoElem.videoHeight;
	        if( webCamWidth > 0 && webCamHeight > 0){
		        margin = ((3 * vw) - w) / 2;
		
		        if( webCamWidth > webCamHeight ){
		            videoObj.style.height = (3 * vw) + "px";
		            videoObj.style.width  = (3 * vw * webCamWidth / webCamHeight) + "px";
		
		            videoObj.style.top = -margin + "px";
		            videoObj.style.left =  "-" + (margin + (videoObj.clientWidth - videoObj.clientHeight) / 2) + "px";
		        }else{
		            videoObj.style.width = (3 * vw) + "px";
		            videoObj.style.height = (3 * vw * webCamHeight / webCamWidth) + "px";
		
		            videoObj.style.left = -margin + "px";
		            videoObj.style.top = "-" + (margin + (videoObj.clientHeight - videoObj.clientWidth) / 2) + "px";
		        }
		        
		        
		        if( webCamWidth < webCamHeight ){
		            videoWidth.current = filterSize;
		            videoHeight.current = videoWidth.current * webCamHeight / webCamWidth;
		            
		            filterTop.current = (videoHeight.current - filterSize) / 2;
		            filterLeft.current = 0; 
		        } else {
		            videoWidth.current = filterSize * webCamWidth / webCamHeight;
		            videoHeight.current = filterSize;
		            
		            filterTop.current = 0;
		            filterLeft.current = (videoWidth.current - filterSize) / 2; 
		        }
		
		        dispElem.width  = videoWidth.current;
		        dispElem.height = videoHeight.current;
	        }
	      }
	      contentInner.style.width =  w + "px";
	    }
	}
  
    var videoElem   = document.getElementById("video_obj");
	if( maskObj !== null ){
		
		var ua = navigator.userAgent;
		if (ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0 ) {
		  if( window.orientation % 180 !== 0 ){
		    videoWidth.current = sizeHeight;
		    videoHeight.current = sizeWidth;
		    filterLeft.current = 40;
		  }else{
		    videoWidth.current = sizeWidth;
		    videoHeight.current = sizeHeight;
		    filterTop.current = 40;
		  }
		} else {
		  videoWidth.current = sizeHeight;
		  videoHeight.current = sizeWidth;
		  filterLeft.current = 40;
		}
		var pixels;
		var drawFlag = false;
	
		
	 	dispElem.width  = videoWidth.current;
		dispElem.height = videoHeight.current;
		
		var objMatchRate = 0.8;
		
		var filterList = [];
	    var workList   = [];
	    var pointList  = [];
	    var filterImgList = [];
	    var matchRate  = 0;
	    var disMatchRate = 0;
	    
        pointList = maskObj.point;

        if( maskObj.filter.length > 0 ){
            for( var i = 0;i < maskObj.filter.length;i++ ){
                var filterElem    = document.createElement("canvas");

                filterElem.width  = filterWidth;
                filterElem.height = filterSize;

                var canvalId = "#filter" + i + "_img";

                var filterImg = new Image();
                filterImg.canvasId = canvalId;
                filterImg.src = maskObj.filter[i];
                filterImgList.push( filterImg );

                filterList.push( filterElem );
                workList.push(new Array(filterWidth * filterSize));
            }
        }

        matchRate = maskObj.match;
        disMatchRate = maskObj.dis_match;

		const modelFrameObj = document.getElementById("model_frame");
		const fixedFrameObj = document.getElementById("fixed_frame");
		modelFrameObj.src = './images/model' + model + '_' + type + '_matching.png';
		fixedFrameObj.src = './images/model' + model + '_fixed.png';

        handleWindowResize();
		window.addEventListener('resize', handleWindowResize);
		
		const dp = function(x, y){
        	return ( y * depth ) * filterWidth + x * depth;
    	}
    	const checkColor = function( br, bg, bb, x, y ){
	        var p = dp(x, y);
	        var r = pixels.data[p];
	        var g = pixels.data[p + 1];
	        var b = pixels.data[p + 2];
	
	        var dr = Math.abs(br - r);
	        var dg = Math.abs(bg - g);
	        var db = Math.abs(bb - b);
	
	        if((dr < 40) && (dg < 30) && (db < 30) ){
	            return true;
	        }
	        return false;
        }
		const myDraw = function(){
	        if( !drawFlag && videoElem.srcObject != null ){
	            drawFlag = true;
	            
		        var dispCtx   = dispElem.getContext('2d');
	            dispCtx.drawImage(videoElem, webCamWidth / 3, webCamHeight / 3, webCamWidth / 3, webCamHeight / 3, 0, 0, dispElem.width, dispElem.height);
				if( startMatchFlag.current && (!isSpecialFlag || isHorizon )){
		            pixels = dispCtx.getImageData(filterLeft.current, filterTop.current, filterWidth, filterSize);
		            
		            var i, j, x, y;
		            var matchCount = 0;
		
		            for( i = 0;i < workList.length;i++ ){
		                var workObj = workList[i];
		                for( j = 0;j < workList[i].length;j++ ){
		                    workObj[j] = 0;
		                }
		
		                var cx, cy;
		                if( i < pointList.length ){
		                    cx = pointList[i].x;
		                    cy = pointList[i].y;
		                }else{
		                    cx = Math.floor(filterWidth / 2);
		                    cy = Math.floor(filterSize / 2);
		                }
		                j = dp(cx, cy);
		                var br = pixels.data[j];
		                var bg = pixels.data[j + 1];
		                var bb = pixels.data[j + 2];
		
		                if((br === 0) && (bg === 0) && (bb === 0)){
		                    break;
		                }
		
		                var ctx = filterList[i].getContext('2d');
		
		                ctx.drawImage(filterImgList[i], 0, 0, filterWidth, filterSize, 0, 0, filterWidth, filterSize);
		                var filterPixels = ctx.getImageData(0, 0, filterWidth, filterSize);
		
		                var matchFlag = 0;
		                var disMatchFlag = 0;
		                var mc = 0;
		                var dc = 0;
		                for( y = 0;y < filterSize;y++ ){
		                    for( x = 0;x < filterWidth;x++ ){
		                        j = dp( x, y );
		                        var key = filterPixels.data[j];
		
		                        if( key === 0 ){
		                            dc++;
		                            if( !checkColor( br, bg, bb, x, y )){
		                                disMatchFlag++;
		                            }
		                        }else if( key === 255 ){
		                            mc++;
		                            if( checkColor( br, bg, bb, x, y )){
		                                matchFlag++;
		                            }
		                        }
		                    }
		                }
		                if( ( disMatchFlag / dc >= disMatchRate ) && ( matchFlag / mc >= matchRate ) ){
		                    matchCount++;
		                }
		            }
		            if( matchCount / workList.length >= objMatchRate ){
		                onMatchModel();
		            }
		        }
	
	            drawFlag = false;
	            requestAnimationFrame(myDraw);
	        }
  		}
  		const onMatchModel = function(){

	        startMatchFlag.current = false;
	
	        var foundModelList = commonDatas.loadFoundList();
	
	        var param = model.split("_");
	        var gid = parseInt(param[0]) - 1;
	        var oid = parseInt(param[1]) - 1;
	        foundModelList[gid][oid] = true;
	
	        commonDatas.setCookie( "found_model", JSON.stringify(foundModelList) );
	        modelFrameObj.style.display = "none";
	        fixedFrameObj.style.visibility = "visible";
	        
	        var cameraObj;
	        if( isSpecialFlag ){
		        cameraObj = document.getElementById("camera_horizon");
			}else{
		        cameraObj = document.getElementById("camera");
	        }
	        cameraObj.classList.add("match");
	
			commonDatas.setCookie( "last_found_model", model );
		    commonDatas.setCookie( "last_found_model_type", typeNo );
	    }
  
	    if ((navigator.mediaDevices) && (navigator.mediaDevices.getUserMedia)) {
	        var settings;
	        settings = {video: {
	            facingMode: {
	                exact: "environment"
	            }
	        }};
	        navigator.mediaDevices.getUserMedia(settings)
	            .then(
	                function(stream) {
	                    videoElem.srcObject = stream;
	                    videoElem.onloadedmetadata = function(e){
	
	                        webCamWidth = e.srcElement.videoWidth;
	                        webCamHeight = e.srcElement.videoHeight;
	
	                        isVideoLoaded = true;
	                        onResizeCameraProc();
	
	                        videoElem.play();
							setIsLoading(false);
	                    };
	                    requestAnimationFrame(myDraw);
	                })
	            .catch(function(err) {
	                settings = {video: true};
	                navigator.mediaDevices.getUserMedia(settings)
	                .then(
	                    function(stream) {
	                        videoElem.srcObject = stream;
	                        videoElem.onloadedmetadata = function(e){
	                            webCamWidth = e.srcElement.videoWidth;
	                            webCamHeight = e.srcElement.videoHeight;
	
	                            isVideoLoaded = true;
	                            onResizeCameraProc();
	                            
	                            videoElem.play();
								setIsLoading(false);
	                        };
	                        requestAnimationFrame(myDraw);
	                    })
	                .catch(function(err) {
						setIsError(true);
						setIsLoading(false);
	                });
	            });
	    }else{
	  		setIsError(true);
			setIsLoading(false);
	    }
    }
    if( baseIsError ){
	  navigate("/list");
	}
                
    return () => {
		window.removeEventListener('resize', handleWindowResize);		
		if( videoElem.srcObject != null ){
			const tracks = videoElem.srcObject.getTracks();
			tracks.forEach(track => {
			  track.stop();
			});
		}
		videoElem.srcObject = null;
		document.documentElement.style.setProperty('--content_width', "100vw"); 
	}
  }, [maskObj, model, navigate, depth, dispElem, filterSize, filterWidth, isHorizon, isSpecialFlag, baseIsError, sizeHeight, sizeWidth, type, typeNo])
  
  return (
	<>
      <div id={isSpecialFlag ? "camera_horizon": "camera"} className={typeNo === "2" ? "content_wrapper content_type2" : "content_wrapper content_type1"}>
        <div className="content_main_wrapper">
          <div id="video_area">
            <video id="video_obj" autoPlay playsInline></video>
          </div>
          <div className="image_area">
            <img id="model_frame" width="100%" alt="" />
            <img id="fixed_frame" width="100%" alt="" />
          </div>
          <div id="content_inner" className="content_inner">
            <div className="pt655 mb40">
              <div className="matching_arrow mb30"><img src="./images/match_arrow.png" width="100%" alt="" /></div>
              <div className={isSpecialFlag ? "matching_label attention_inner_header mb40" : "matching_label attention_inner_header mb55"}>おっとっとをここにあわせてね</div>
              {!isSpecialFlag ? 
                   <div className="matched_label pt120 mb40">
                     <div className="mb10"><img src={"./images/label_model" + model + ".png"} width="80.4%" alt="ぴったりはまったね！" /></div>
                     <div className="mb140"><img src="./images/match_complete_text.png" width="80.4%" alt="ぴったりはまったね！" /></div>
                     <Link to="/list" id="btn_movie"><img src="./images/btn_movie.png" width="64%" alt="動画はこちら" /></Link>
                   </div> 
                 : 
                   <div className="matched_label btn_movie">
                     <Link to="/list" id="btn_movie"><img src="./images/btn_movie.png" width="100%" alt="動画はこちら" /></Link>
                   </div>
              }
              <div className="attention_inner left">
                <ul>
                  <li className="infomation mb20">室内外の環境光によって認識しづらい場合がございます</li>
                  <li className="infomation mb20">割れている・欠けている菓子は形を読み取れない可能性がございます</li>
                  <li className="infomation mb20">菓子色と背景の色が似ていると認識しづらい場合がございます。その場合は濃い色の背景の上で読み取りください</li>
                  <li className="infomation mb20">端末のカメラによっては認識しづらい場合がございます</li>
                  <li className="infomation">形を読み込む際は、菓子を置いておこなってください</li>
                </ul>
              </div>
              <div className="btn_back"><Link to="/list"><img src="./images/btn_back.png" width="100%" alt="もどる" /></Link></div>
            </div>
            <div className={isSpecialFlag ? "copyright" : "pb40 copyright"}><img src="./images/copyright.png" width="100%" alt="Copyright © MORINAGA & CO., LTD. All rights reserved." /></div>
            </div>
        </div>

        {isStart && isSpecialFlag ? <div id="start_popup" className="over_popup">
          <div className="start_popup_inner">
            <div className="pt40 mb50"><img src={typeNo === "2" ? "./images/popup1_image2_hori.png" : "./images/popup1_image_hori.png"} width="57.8%" alt="" /></div>
            <div className="mb40"><img src="./images/popup1_label_hori.png" width="64.618%" alt="おっとっとにカメラをむけてシルエットにあわせてね" /></div>
            <div className="pb50"><a className="close_popup" href="/#" onClick={(e) => onStartPopupCloseClick(e)}><img src="./images/btn_ok.png" width="45.127%" alt="わかった" /></a></div>
          </div>
        </div> : null}
        {isStart && !isSpecialFlag ? <div id="start_popup" className="over_popup">
          <div className="pt175 mb85"><img src={typeNo === "2" ? "./images/popup1_image2.png" : "./images/popup1_image.png"} width="52.8125%" alt="" /></div>
          <div className="mb90"><img src="./images/popup1_label.png" width="74.375%" alt="おっとっとにカメラをむけてシルエットにあわせてね" /></div>
          <div className="pb50"><a className="close_popup" href="/#" onClick={(e) => onStartPopupCloseClick(e)}><img src="./images/btn_ok.png" width="80.267%" alt="わかった" /></a></div>
        </div> : null}
        {isError && isSpecialFlag ? <div id="error_popup" className="over_popup">
          <div className="error_popup_inner">
            <div className="pt30 mb30"><img src="./images/popup2_image.png" width="18.29%" alt="" /></div>
            <div className="mb15"><img src="./images/popup2_label1_hori.png" width="46.627%" alt="もういちどやってみてね カメラの起動が確認できませんでした。" /></div>
            <div className="mb40">
              <img src="./images/popup2_label2.png" width="13.793%" alt="動作環境については" />
              <Link to="/"><img src="./images/popup2_label3.png" width="9.37%" alt="トップページ" /></Link>
              <img src="./images/popup2_label4.png" width="12.519%" alt="でご確認ください" />
            </div>
            <div><Link id="btn_error" to="/list"><img src="./images/btn_back.png" width="45.127%" alt="もどる" /></Link></div>
          </div>
        </div> : null}
        {isError && !isSpecialFlag ? <div id="error_popup" className="over_popup">
          <div className="pt175 mb70"><img src="./images/popup2_image.png" width="32.533%" alt="" /></div>
          <div className="mb30"><img src="./images/popup2_label1.png" width="54%" alt="もういちどやってみてね カメラの起動が確認できませんでした。" /></div>
          <div className="mb40">
            <img src="./images/popup2_label2.png" width="24.533%" alt="動作環境については" />
            <Link to="/"><img src="./images/popup2_label3.png" width="16.667%" alt="トップページ" /></Link>
            <img src="./images/popup2_label4.png" width="22.267%" alt="でご確認ください" />
          </div>
          <div><Link id="btn_error" to="/list"><img src="./images/btn_back.png" width="80.267%" alt="もどる" /></Link></div>
        </div> : null}

		{isSpecialFlag && !isHorizon ? <div id="orientation_modal" className="overlay orientation_modal">
          <div className="modal_inner">
            <div className="orientation_modal_text"><img src="./images/img_hori_alert.png" alt="スマートフォンをよこにしてあそんでね" width="100%" /></div>
          </div>
        </div> : null}
          
        {isLoading ? <div id="loading" className="overlay">
          <div className="loading_wrapper">
            <div className="loading_inner">
              <div className="sk-fading-circle">
                <div className="sk-circle1 sk-circle"></div>
                <div className="sk-circle2 sk-circle"></div>
                <div className="sk-circle3 sk-circle"></div>
                <div className="sk-circle4 sk-circle"></div>
                <div className="sk-circle5 sk-circle"></div>
                <div className="sk-circle6 sk-circle"></div>
                <div className="sk-circle7 sk-circle"></div>
                <div className="sk-circle8 sk-circle"></div>
                <div className="sk-circle9 sk-circle"></div>
                <div className="sk-circle10 sk-circle"></div>
                <div className="sk-circle11 sk-circle"></div>
                <div className="sk-circle12 sk-circle"></div>
              </div>
              <div className="loading_test">Now Loading</div>
            </div>
          </div>
        </div> : null}
      </div>
	</>
  );
};